export default __webpack_public_path__ + "static/media/Harukaze.15baf02a.ttf";